import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type VideoFirstExperiment = PetitionDetailsPageUserData['experiments']['videoFirstPetitionPage'];

type Result = Readonly<{
	experiment: VideoFirstExperiment;
	hasVideoFirstSource: boolean;
	videoFirstSourceUrl: string | undefined;
}>;

export function useVideoFirstExperiment(): Result {
	const {
		data: { videoFirstHero },
	} = usePetitionDetailsPageData();
	const {
		data: {
			experiments: { videoFirstPetitionPage: experiment },
		},
	} = usePetitionDetailsPageUserData();

	const hasVideoFirstSource = videoFirstHero.enabled;
	const videoFirstSourceUrl =
		videoFirstHero.enabled && experiment.variation === 'video_first' ? videoFirstHero.sourceUrl : undefined;

	return { experiment, hasVideoFirstSource, videoFirstSourceUrl };
}
